import instanceAxios from '../config/api'
import {
  ActionImportSource,
  ExtractActionsResponse,
  ImportActionPayload,
} from '../types/actionImportTypes'
import { Action } from '../types/actionTypes'

const API_URL = '/action-import'

/** Extraction can call an LLM for column mapping, so it may take a while. */
const EXTRACT_TIMEOUT_MS = 5 * 60 * 1000

export const extractActionsApi = async ({
  source,
  file,
  signal,
}: {
  source: ActionImportSource
  file?: File | null
  signal?: AbortSignal
}): Promise<ExtractActionsResponse> => {
  const formData = new FormData()
  formData.append('source', source)
  if (file) formData.append('file', file)

  const response = await instanceAxios.post<ExtractActionsResponse>(
    `${API_URL}/extract`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: EXTRACT_TIMEOUT_MS,
      signal,
    }
  )
  return response.data
}

export const importActionApi = async (
  payload: ImportActionPayload
): Promise<Action> => {
  const response = await instanceAxios.post<Action>(
    `${API_URL}/import`,
    payload
  )
  return response.data
}
